<ng-container *ngIf="notes?.items.length">
  <boma-pagination
    [pageSize]="pageSize * 1"
    [results]="notes"
    (refreshPage)="refreshNotes()"
    (updatePage)="loadPage($event)"
    (updatePageSize)="updatePageSize($event)"
  ></boma-pagination>

  <div *ngFor="let note of notes?.items" class="note mb-2">
    <div class="card-user">
      <strong>{{ note.user.name }} {{ note.user.surname }}</strong>
      <!-- TODO Replace with friendly Date -->
      {{ note?.createdAt | date: 'dd/MM/yyyy, HH:mm:ss' }}
    </div>
    <div class="box-section p-1" [title]="note.identifier">
      <div class="card-title" *ngIf="showTitle">{{ note.title }}</div>
      <div class="card-content">{{ note.content }}</div>

      <div class="images" *ngIf="note.images">
        <ng-container *ngFor="let image of note.images">
          <!-- {{ image | json }} -->
          <img
            [src]="image.url"
            style="max-width: 200px"
            (click)="loadImage(image.url)"
            class="cursor-pointer rounded-thumbnail mr-2"
          />
        </ng-container>
        <p-dialog header="Image" [(visible)]="displayImageModal">
          <ng-container *ngIf="imageLoading">
            <boma-anim-spinning-loader></boma-anim-spinning-loader>
          </ng-container>

          <img
            *ngIf="selectedImageURL"
            [src]="selectedImageURL"
            (load)="onImageLoad(selectedImageURL)"
            (error)="onImageError()"
          />
        </p-dialog>
      </div>
    </div>
    <!-- edit reply -->
  </div>
</ng-container>
